/* eslint-disable react/jsx-curly-newline */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Drawer, Form, Input, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useApi } from '../../hooks/api';
import IIntegrationsList from '../../interfaces/integrationsList';
import IClientsList from '../../interfaces/clients';
import { medias } from '../../constants/medias';
import { IBroker } from '../../interfaces/broker';

interface IProps {
  showFilters: boolean;
  closeFilters: () => void;
  search(
    media: string,
    broker: string,
    client: string,
    integration: string,
    request_sent_at: string,
    origin: string,
    request_id: string,
    destination: string
  ): void;
}

const { Option } = Select;

const LogInteractionsFilters: React.FC<IProps> = props => {
  const { showFilters, closeFilters, search } = props;
  const [brokers, setBrokers] = useState<IBroker[]>([]);
  const [integrations, setIntegrations] = useState<IIntegrationsList[]>([]);
  const [clients, setClients] = useState<IClientsList[]>([]);

  const { api } = useApi();

  const [form] = useForm();

  const loadClients = useCallback(async () => {
    const response = await api.get('/clients');
    setClients(response.data);
  }, [api]);

  const loadIntegrations = useCallback(async () => {
    const { data } = await api.get(`/integrations`);
    setIntegrations(data);
  }, [api]);

  const loadBrokers = useCallback(async (media_name: string) => {
        form.setFieldsValue({
          [`broker`]: '',
        });
        const response = await api.get(`/integrations-config/brokers/${media_name}`);
        setBrokers(response.data.sort());
      }, [api, form]);
    
  const handleChangeMedia = (media: string) => {
      loadBrokers(media);
  };

  const onSearch = useCallback(() => {
    const { media, broker, client, integration, request_sent_at, origin, request_id, destination } =
      form.getFieldsValue();

    search(
      media === undefined ? '' : media,
      broker === undefined ? '' : broker,
      client === undefined ? '' : client,
      integration === undefined ? '' : integration,
      request_sent_at === undefined ? '' : request_sent_at,
      origin === undefined ? '' : origin,
      request_id === undefined ? '' : request_id,
      destination === undefined ? '' : destination,
    );
  }, [search, form]);

  useEffect(() => {
    loadIntegrations();
    loadClients();
  }, [loadIntegrations, loadClients]);

  return (
    <Drawer
      title="Filtros de pesquisa"
      placement="right"
      closable={false}
      onClose={closeFilters}
      visible={showFilters}
    >
      <Form layout="vertical" onFinish={onSearch} form={form}>
        <Col span={24}>
          <Form.Item label="Request ID" name="request_id">
            <Input
              className="dcs-input"
              allowClear
              type="text"
              placeholder="ex.: 17a91468-46ba-4fa3-9c34-4b6e5db4833f"
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Destino" name="destination">
            <Input
              className="dcs-input"
              allowClear
              type="text"
              placeholder="ex.: 5583999887766"
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Canal:" name="media">
            <Select
              allowClear
              showSearch
              placeholder="Canal"
              filterOption
              optionFilterProp="children"
              className="dcs-select"
              onChange={value => handleChangeMedia(String(value))}
            >
              {medias
                .sort((a, b) => a.label.localeCompare(b.label))
                .map(media => {
                  return (
                    <Option key={media.value} value={media.value}>
                      {media.label}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Broker:" name="broker">
            <Select
              allowClear
              showSearch
              placeholder="Broker"
              filterOption
              optionFilterProp="children"
              className="dcs-select"
            >
              {brokers.map(item => (
                  <Option key={item.id} value={item.broker}>
                    {item.broker.toUpperCase()}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Cliente:" name="client">
            <Select
              allowClear
              showSearch
              placeholder="Cliente"
              filterOption
              optionFilterProp="children"
              className="dcs-select"
            >
              {clients.map(client => {
                return (
                  <Option key={client.id} value={client.id}>
                    {client.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Integração:" name="integration">
            <Select
              allowClear
              showSearch
              placeholder="Integração"
              filterOption
              optionFilterProp="children"
              className="dcs-select"
            >
              {integrations.map(integration => {
                return (
                  <Option key={integration.id} value={integration.id}>
                    {integration.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Data" name="request_sent_at">
            <Input className="dcs-input" allowClear type="date" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Origem" name="origin">
            <Select
              className="dcs-select" 
              allowClear          
              placeholder="DCS/Webhook"
              options={[
                { value: 'dcs', label: 'dcs' },      
                { value: 'webhook', label: 'webhook' },
              ]}
            />
          </Form.Item>
        </Col>
        <Form.Item>
          <Button type="primary" shape="round" htmlType="submit">
            Filtrar
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default LogInteractionsFilters;
